module.exports = __webpack_public_path__ + "img/Confirm_Green-min.30debde3.png";